import type { LoaderFunctionArgs } from '~/types/route-args';
import { getNewsletterSubscriptionStatus } from '@modules-rocco/subscription/api/get-newsletter-subscription-status.server';

/** Deferred endpoint for the current member's newsletter subscription state. */
export const NEWSLETTER_STATUS_API_ROUTE = '/remix-api/user/newsletter-status';

export const loader = async ({ context }: LoaderFunctionArgs) => {
    try {
        const subscribed = await getNewsletterSubscriptionStatus(context);
        return { subscribed };
    } catch {
        // Degrade to "not subscribed" so the homepage keeps showing the prompt
        // rather than surfacing an error.
        return { subscribed: false };
    }
};
